import { Selector, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './command-progress.reducer';
import * as fromState from './command-progress.state';

import { CommandProgress, RequestType } from '@rocksoft/mdm-sdk-v2';
import { DevicesRouterStoreSelectors } from '../router';

export const selectCommandProgressState: Selector<object, fromState.CommandProgressState> =
  createFeatureSelector<fromState.CommandProgressState>(fromReducer.commandProgressFeatureKey);

export const selectAllCommandProgress = createSelector(
  selectCommandProgressState,
  fromReducer.selectAllCommandProgress
);

export const selectCommandProgressEntities = createSelector(
  selectCommandProgressState,
  fromReducer.selectCommandProgressEntities
);

export const selectCommandProgressIds = createSelector(
  selectCommandProgressState,
  fromReducer.selectCommandProgressIds
);

// reduce the union type to only string because we know it is
export const selectCommandProgressesForCurrentUdid = createSelector(
  DevicesRouterStoreSelectors.selectUdid,
  selectCommandProgressIds,
  selectCommandProgressEntities,
  (udid, ids, commandProgresses) =>
    udid && commandProgresses
      ? (ids as string[]).filter((x) => x.startsWith(udid)).map((key) => commandProgresses[key])
      : []
);

export const selectCommandProgressByUdid = (udid: string) =>
  createSelector(selectAllCommandProgress, (commandProgresses: CommandProgress[]) =>
    commandProgresses.filter((x) => x.udid === udid)
  );

export const selectCommandProgressByUdidAndRequestType = (udid: string, requestType: RequestType) =>
  createSelector(selectCommandProgressByUdid(udid), (commandProgresses: CommandProgress[]) => {
    const commands = commandProgresses.filter((x) => x.requestType === requestType);

    // We want to take the latest command status for the given udid and request type. Because the order
    // of the store is guaranteed, its safe to just pick the first item.
    return commands.length > 0 ? commands[0] : undefined;
  });

// Selector to select command progress that match the RequestType
// Because of the sorting, index 0 is the most recently added command progress
export const selectCommandProgressForCurrentUdidByRequestType = (requestType: RequestType) =>
  createSelector(selectCommandProgressesForCurrentUdid, (commandProgresses) => {
    return commandProgresses.find((progress) => progress?.requestType === requestType) || null;
  });
